import { HelperContext } from "../../Helper/helper.context";

import ImgHelpWindrose from '../../../images/help_context/wind_rose.png';

export const WindroseHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div className="pos-relative flex-grow-1">
                <div className="help-context-item">
                    <img src={ImgHelpWindrose}/>
                </div>
            </div>
        }
    />    
)}